import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

export default (url, fileName, opts = {}) => {
  return errorHandler(
    Vue.$http({
      url,
      method: 'GET',
      responseType: 'arraybuffer',   // ← OBLIGATORIO
      ...opts.config,                // params también vienen aquí
    })
  )
  .then((response) => {
    const mime =
      response.headers['content-type'] ||
      'application/octet-stream'

    const blob = new Blob([response.data], { type: mime })

    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    return blob.size
  })
  .catch((err) => {
    throw err
  })
}



// WEBPACK FOOTER //
// ./src/utils/downloadFile.js